// // Snow effect
// document.addEventListener('DOMContentLoaded', function () {
//     const numFlakes = 100; // Number of snowflakes
//     const snowflakes = [];

//     function createSnowflake() {
//         const snowflake = document.createElement('div');
//         snowflake.className = 'snowflake';
//         snowflake.style.position = 'absolute';
//         snowflake.style.left = Math.random() * window.innerWidth + 'px';
//         snowflake.style.opacity = Math.random();
//         snowflake.style.fontSize = Math.random() * 10 + 10 + 'px'; // Size range
//         snowflake.innerHTML = '❄'; // Snowflake character
//         document.body.appendChild(snowflake);
//         snowflakes.push(snowflake);

//         // Animate snowflake
//         setTimeout(() => {
//             snowflake.style.transform = 'translateY(' + (window.innerHeight + 50) + 'px)';
//             snowflake.style.transition = 'transform 5s linear';
//         }, 50);

//         // Remove snowflake after animation
//         setTimeout(() => {
//             snowflake.remove();
//         }, 5050);
//     }

//     for (let i = 0; i < numFlakes; i++) {
//         createSnowflake();
//     }

//     setInterval(createSnowflake, 300); // Create new snowflakes every 300 ms
// });

document.addEventListener('DOMContentLoaded', function () {
    const numFlakes = 100; // Number of initial snowflakes
    const creationInterval = 300; // Interval for new snowflakes in ms

    function createSnowflake() {
        const snowflake = document.createElement('div');
        snowflake.className = 'snowflake';

        // Set styles for the snowflake
        snowflake.style.position = 'absolute';
        snowflake.style.left = Math.random() * (window.innerWidth - 20) + 'px'; // Subtract width to prevent overflow
        snowflake.style.opacity = Math.random();
        snowflake.style.fontSize = Math.random() * 10 + 10 + 'px'; // Size range
        snowflake.innerHTML = '❄'; // Snowflake character
        document.body.appendChild(snowflake);

        // Randomize the starting position
        snowflake.style.top = Math.random() * -50 + 'px'; // Start above the viewport

        // Animate snowflake with random falling duration
        const fallDuration = Math.random() * 15 + 10; // Random duration between 10s and 25s
        setTimeout(() => {
            snowflake.style.transform = `translateY(${window.innerHeight + 50}px)`;
            snowflake.style.transition = `transform ${fallDuration}s linear`;
        }, 50);

        // Remove snowflake after animation
        setTimeout(() => {
            snowflake.remove();
        }, fallDuration * 1000 + 100); // Adjust based on fall duration
    }

    // Randomly stagger the initial snowflakes
    for (let i = 0; i < numFlakes; i++) {
        setTimeout(createSnowflake, Math.random() * creationInterval * numFlakes);
    }

    // Continue creating snowflakes periodically
    setInterval(createSnowflake, creationInterval);
});

